import { DefaultRootState } from 'react-redux';
import { Middleware } from 'redux';
import * as undoActions from '../actions/undo.actions';

export const undoMiddleware: Middleware<
  Record<string, unknown>,
  DefaultRootState
> = ({ getState, dispatch }) => (next) => (action) => {
  const previousState = getState();
  const thisNext = next(action);

  if (action.meta?.history === false) {
    // Logging is disabled for this action
    return thisNext;
  }

  const nextState = getState();

  const { diff: toPrevious, changed: previousChanged } = getDiff(
    previousState,
    nextState,
  );

  const { diff: toNext, changed: nextChanged } = getDiff(
    nextState,
    previousState,
  );

  if (previousChanged || nextChanged) {
    dispatch(
      undoActions.saveUndoState({
        toPrevious,
        toNext,
        meta: { history: false },
      }),
    );
  }

  return thisNext;
};

const getDiff = <State>(
  previousState: State,
  nextState: State,
): { diff: Partial<State>; changed: boolean } => {
  const diff: any = {};
  let changed = false;
  for (const key in previousState) {
    const previousSlice = previousState[(key as unknown) as keyof State];
    const nextSlice = nextState[(key as unknown) as keyof State];

    if (previousSlice !== nextSlice) {
      diff[key] = {};
      for (const k in previousSlice) {
        if (previousSlice[k] !== nextSlice[k]) {
          changed = true;
          diff[key][k] = previousSlice[k];
        }
      }
    }
  }

  return { diff, changed };
};
